import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import TitledCard from "../../../../components/UI/TitledCard";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import PercentageNumber from "../../../../components/UI/PercentageNumber";
import feeAction from "../../../../actions/fee.action";
import { connect } from "react-redux";

const styles = (theme) => ({
  slider: {
    maxWidth: "calc(60% - 54px)",
    marginLeft: "27px",
  },
  expansionPanel: {
    background: "transparent",
    margin: 0,
    "&:before": {
      opacity: 0,
    },
  },
  expansionPanelDetails: {
    padding: 0,
  },
  expansionPanelExpanded: {
    margin: 0,
  },
  expansionPanelSummary: {
    padding: 0,
    minHeight: 1,
  },
  expansionPanelSummaryExpanded: {
    padding: 0,
    minHeight: 1,
  },
});

class AdvisorFeeDataBox extends React.Component {
  state = {
    advisorFee: this.props.advisorDefaultFeeRate,
    expanded: "advisorFee",
  };

  toggleExpansion = (name) => (event, expanded) => {
    this.setState({ expanded: expanded ? name : "" });
  };

  handleSlide = (event, newValue) => {
    this.setState({
      advisorFee: newValue,
    });
  };

  saveDefaultAdvisorBaseFee = (e) => {
    this.props.dispatch(
      feeAction.updateDefaultAdvisorRate(this.state.advisorFee)
    );
  };

  render() {
    const { classes } = this.props;
    const { advisorFee, expanded } = this.state;

    return (
      <TitledCard titleText="Fee Details">
        <Accordion
          classes={{
            root: classes.expansionPanel,
            expanded: classes.expansionPanelExpanded,
          }}
          onChange={this.toggleExpansion(`advisorFee`)}
          expanded={expanded === "advisorFee"}
          elevation={0}
        >
          <AccordionSummary
            classes={{
              root: classes.expansionPanelSummary,
              expanded: classes.expansionPanelSummaryExpanded,
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={5}>
                <Typography id="base-advisor-fee" variant={"body2"}>
                  Base Advisor Fee
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography
                  variant={"body2"}
                  color={"primary"}
                  data-cy="fees.advisor.value"
                >
                  <PercentageNumber decimal={2} value={advisorFee / 100} />
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails className={classes.expansionPanelDetails}>
            <Slider
              className={classes.slider}
              value={advisorFee}
              name={"advisorFee"}
              aria-labelledby="base-advisor-fee"
              min={0}
              max={1.5}
              step={0.05}
              onChange={this.handleSlide}
              disabled={this.props.readonly}
              data-cy="fees.advisor.slider"
            />
          </AccordionDetails>
        </Accordion>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: 40 }}
          onClick={this.saveDefaultAdvisorBaseFee}
          data-cy="fees.advisor.submit"
        >
          Save
        </Button>
      </TitledCard>
    );
  }
}

const mapStateToProps = (state) => {
  const advisorDefaultFeeRate = Number(state.fee.advisorDefaultFeeRate);
  return {
    advisorDefaultFeeRate,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(AdvisorFeeDataBox));



// WEBPACK FOOTER //
// ./src/containers/Cy/components/AdvisorFeeDataBox/index.jsx